import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Nav from './components/Nav';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import HomeStory from './components/home/HomeStory';

import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import IoTSolutionsPage from './pages/IoTSolutionsPage';
import BlogPage from './pages/BlogPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import BlogPostPage from './pages/BlogPostPage';

// Service pages
import IoTProductPage from './pages/IoTProductPage';
import EmbeddedHardwarePage from './pages/EmbeddedHardwarePage';
import EmbeddedFirmwarePage from './pages/EmbeddedFirmwarePage';
import IoTDashboardsPage from './pages/IoTDashboardsPage';
import IoTCloudPage from './pages/IoTCloudPage';
import ResearchRnDPage from './pages/ResearchRnDPage';

import SectorsPage from './pages/SectorsPage';

// Preview of the new scroll-told services section at /services-story.
// Not linked from the homepage.
import ServicesStoryPage from './pages/ServicesStoryPage';

// Industry pages
import HealthcarePage from './pages/industries/HealthcarePage';
import UtilitiesEnergyPage from './pages/industries/UtilitiesEnergyPage';
import IndustrialIoTPage from './pages/industries/IndustrialIoTPage';
import EducationPage from './pages/industries/EducationPage';
import ServiceDetailPage from './pages/ServiceDetailPage';

/* The homepage is one scroll-told build: blueprint → board → enclosure →
   integration → validation → deployment → industries → capabilities →
   projects → proof. See components/home/HomeStory.jsx. The previous
   homepage sections (PcbJourney, Hero, About, ServicesStory, …) are left in
   place, unused here, so the old page is one import away. */
function HomePage() {
  return (
    <>
      <Helmet>
        <title>Zone-X — Engineering. Innovation. Excellence.</title>
        <meta name="description" content="Zone-X Laboratories — Advanced IoT, embedded systems, AI/ML, and full-stack engineering solutions. 8+ years, 120+ products shipped, 45 engineers, 12 industries." />
        <link rel="canonical" href="https://zone-x.dev/" />
      </Helmet>
      <HomeStory />
      <Footer hideCTA />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* <Cursor /> */}
      <Nav />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/iot-solutions" element={<IoTSolutionsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />

        {/* Projects / case studies */}
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:slug" element={<ProjectDetailPage />} />

        {/* Service pages */}
        <Route path="/iot-product-design-services" element={<IoTProductPage />} />
        <Route path="/embedded-hardware-design" element={<EmbeddedHardwarePage />} />
        <Route path="/embedded-firmware-development" element={<EmbeddedFirmwarePage />} />
        <Route path="/iot-dashboards-web-mobile" element={<IoTDashboardsPage />} />
        <Route path="/iot-cloud-integration" element={<IoTCloudPage />} />
        <Route path="/research-innovation-rnd" element={<ResearchRnDPage />} />

        {/* Industry pages */}
        <Route path="/industries/healthcare" element={<HealthcarePage />} />
        <Route path="/industries/utilities-energy" element={<UtilitiesEnergyPage />} />
        <Route path="/industries/industrial-iot" element={<IndustrialIoTPage />} />
        <Route path="/industries/education" element={<EducationPage />} />
        <Route path="/industries/:sectorSlug/:serviceSlug" element={<ServiceDetailPage />} />
        <Route path="/sectors" element={<SectorsPage />} />

        {/* Preview: new services section. Not linked from nav. */}
        <Route path="/services-story" element={<ServicesStoryPage />} />
      </Routes>
    </BrowserRouter>
  );
}
